import React from "react";

export function ChangeLog(): React.JSX.Element {
    return (
        <div>
            <ul>
                <li>Updated LGPE chaining display</li>
                <li>Added Oval Charm to BDSP</li>
                <li>Irrelevant data is no longer displayed</li>
                <li>Added FRLG starter soft reset</li>
                <li>Added SOS call rates for species</li>
                <li>Added change log</li>
                <li>Completed framework for Scarlet/Violet</li>
                <li>
                    Added gifs for all Paldean Pokemon. Credits to adamsb0303.
                    Was broken because of cookies, but is fixed now
                </li>
                <li>Added function to export entire Pokedex as CSV</li>
                <li>Added all DLC outbreak Pokemon</li>
                <li>
                    Added final wave of DLC Pokemon, updated shiny gifs/images
                    where applicable
                </li>
                <li>
                    Updated Friend Safari to reflect end of 3DS online services
                </li>
                <li>
                    Added Living Dex tracker page, with ability to import/export
                    progress, as well as track species, forms, and genders
                    obtained
                </li>
                <li>
                    Added support for saving Living Dex progress between session
                </li>
                <li>
                    Cookies and imported files will update for newly added
                    species and forms
                </li>
                <li>Addet Generation filter to Dex tracker</li>
                <li>Addet Legends: ZA and the Mega Dimensions DLC</li>
                <li>
                    Added all Alcremie forms (you will need to re-check the
                    boxes)
                </li>
                <li>
                    Minor bugfixing with Tauros-Paldea counting incorrectly
                    (uncheck and recheck one if its boxes to fix)
                </li>
            </ul>
        </div>
    );
}
